import { spacingClass } from '@/utils/spacing';

/**
 * @param {{ image?: string, imageAlt?: string, quote?: string, author?: string, role?: string, spacing?: string }} props
 */
export function TestimonialBlock({ image, imageAlt = '', quote, author, role, spacing = 'normal' }) {
  return (
    <section className={'px-6 md:px-16 bg-theme-bg-subtle ' + spacingClass(spacing)}>
      <div className="max-w-3xl mx-auto text-center">
        {image && (
          <img src={image} alt={imageAlt || author || ''} className="w-16 h-16 rounded-full object-cover mx-auto mb-8" loading="lazy" decoding="async" />
        )}
        {quote && (
          <blockquote className="font-heading text-h2 font-light text-theme-text leading-snug mb-8">“{quote}”</blockquote>
        )}
        {(author || role) && (
          <p className="text-sm text-theme-text-muted">
            {author && <cite className="not-italic font-medium">{author}</cite>}{author && role ? ' — ' : ''}{role}
          </p>
        )}
      </div>
    </section>
  );
}
